import { FundingNeeds, Needs, NewFundingNeeds, UpdatedFundingNeeds } from 'app/models/dto/funding-needs.model';

export class GetFundingNeeds {
	static readonly type = '[FundingNeeds] GetFundingNeeds';
	constructor(public borrowerId: number) {}
}

export class CreateFundingNeeds {
	static readonly type = '[FundingNeeds] CreateFundingNeeds';
	constructor(public borrowerId: number, public fundingNeeds: NewFundingNeeds) {}
}

export class UpdateFundingNeeds {
	static readonly type = '[FundingNeeds] UpdateFundingNeeds';
	constructor(public borrowerId: number, public fundingNeedsId: number, public fundingNeeds: UpdatedFundingNeeds) {}
}
export class DeleteFundingNeeds {
	static readonly type = '[FundingNeeds] DeleteFundingNeeds';
	constructor(public borrowerId: number, public fundingNeedsId: number) {}
}

export class ClearFundingNeedsStore {
  static readonly type = '[FundingNeeds] ClearFundingNeedsStore';
  constructor() {}
}
